class ProductService {
    constructor(){
        this.baseUrl = window.Shopify?.routes?.root || '/';
        this.DEFAULT_PORCENTAGES = Object.freeze({
            smMatchPorcentage: 50,
            mdMatchPorcentage: 72,
            flMatchPorcentage: 85,
        })
    }

    static instance = null;

    static getInstance() {
        if (!ProductService.instance) {
            ProductService.instance = new ProductService();
        }
        return ProductService.instance;
    }

    async getProduct(handle) {
        try {
            // const baseUrl = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${this.baseUrl}products/${handle}.js`);
            
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            
            const product = await response.json();
            return product; // Let the caller handle the data
        } catch (e) {
            console.warn(`Failed to fetch product ${handle}:`, e);
            return null;
        }
    }

    async getVariant(id) {
        try {
            // const baseUrl = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${this.baseUrl}variants/${id}.js`);
            
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            
            const variant = await response.json();
            return variant; // Let the caller handle the data
        } catch (e) {
            console.warn(`Failed to fetch variant ${id}:`, e);
            return null;
        }
    }

    //Protótipo para caso apareça necessidade de outros usos posteriores.
    // async getCollectionProducts(collectionHandle) {
    //     try {
    //         console.log('tentando pegar coleção');
    //         const response = await fetch(`${this.BASE_URL}collections/${collectionHandle}/products.json`);
    //         console.log(' pegou algo ?');
    //         if (!response.ok) {
    //             throw new Error(`HTTP error: ${response.status}`);
    //         }
    //         const data = await response.json();
    //         return data.products;
    //     } catch (error) {
    //         console.error('Error:', error);
    //         return null;
    //     }
    // }

    // async matchAndGetProduct(productHandle, shopifyHandle) {
    //     console.log('productHandle', productHandle)
    //     console.log('shopifyHandle', shopifyHandle)
    //     const productHandleUndashed = productHandle.replace(/-/g, ' ');
    //     const shopifyHandleUndashed = shopifyHandle.replace(/-/g, ' ');
        
    //     const shopifyLength = shopifyHandleUndashed.split(' ').length;      
    //     const handleArray = productHandleUndashed.split(' ');
        
    //     let  count = 0;
    //     for(const str of handleArray){
    //         if(shopifyHandleUndashed.includes(str)) count++;
    //     }

    //     const matchPercentage = (count / shopifyLength) * 100;

    //     if(shopifyLength <=3 ){
    //         const product = (matchPercentage >= this.DEFAULT_CONFIG.smMatchPorcentage) ? await this.getProduct(shopifyHandle) :  null;
    //         return product;
    //     }
    //     if(shopifyLength <=12 ){
    //         const product = (matchPercentage >= this.DEFAULT_CONFIG.mdMatchPorcentage) ? await this.getProduct(shopifyHandle) :  null;
    //         return product;
    //     }
        
    //     const product = (matchPercentage >= this.DEFAULT_CONFIG.flMatchPorcentage) ? await this.getProduct(shopifyHandle) :  null;
    //     return product;
    // }
}